import React from 'react'
import SlideoutHeader from 'ps-components/Slideout/Header/SlideoutHeader';
import { hideSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { useDispatch } from 'react-redux';

export const ParticipationReportSlideoutHeader = () => {
    const dispatch = useDispatch()
    return (
        <>
            <SlideoutHeader title="Year Over Year" doClose={() => dispatch(hideSlideout())} />
            <div className='pcenter-slideout__header_container'>
                <h1 className='pcenter-slideout__header_title'>Select a Participation Report to Carry Over</h1>
                <p className='pcenter-slideout__header_text'>
                    With this modal, you are able to copy over any previously created custom survey participation report available to you from one survey code to another.
                    All you need to do is select the survey code you want to pull the report from, and then the specific report you are looking to copy over.
                </p>
            </div>
        </>
    )
}
